import { render, staticRenderFns } from "./BuildingForm.vue?vue&type=template&id=7a92b236&scoped=true&"
import script from "./BuildingForm.vue?vue&type=script&lang=ts&"
export * from "./BuildingForm.vue?vue&type=script&lang=ts&"
import style0 from "./BuildingForm.vue?vue&type=style&index=0&id=7a92b236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a92b236",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a92b236')) {
      api.createRecord('7a92b236', component.options)
    } else {
      api.reload('7a92b236', component.options)
    }
    module.hot.accept("./BuildingForm.vue?vue&type=template&id=7a92b236&scoped=true&", function () {
      api.rerender('7a92b236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/BuildingForm.vue"
export default component.exports